import React from 'react';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux"
import LoadingComponent from 'components/Loading/LoadingComponent';
import InspectionAction from 'store/inspection-resource/actions';

function ListOrder({ setSelectedInspection, callbackGetChecklist, selectedInspection }) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)

  return (
    <Row>
      {
        store.inspection.rtwOrder.loading ? <LoadingComponent /> : <>
          {
            store.inspection.rtwOrder.data.map((i, k) => (
              <Col md='12' className={`p-2 px-4 mt-2 ${selectedInspection == i?.id ? 'bg-dark text-white' : 'bg-light'}`} role="button" key={k} onClick={() => {
                setSelectedInspection(i.id)
                dispatch(InspectionAction.getRtwOrderDetail(i.id, callbackGetChecklist))
                dispatch(InspectionAction.getRtwOrderDetailSize(i.id, () => { }))

              }}>
                <span>{i.orderNumber}/{i.companyName}/{i.size} - {i.sequence}</span>
              </Col>
            ))
          }
        </>
      }


    </Row>
  );
}

export default ListOrder;